const collator = new Intl.Collator("es", {
  sensitivity: "base",
  numeric: true,
});

// Devuelve una copia de `lista` ordenada alfabéticamente (sin distinguir
// mayúsculas ni acentos) por el texto que devuelve `texto(item)`.
export const ordenarPorTexto = (lista, texto) =>
  Array.isArray(lista)
    ? [...lista].sort((a, b) =>
        collator.compare(String(texto(a) ?? ""), String(texto(b) ?? "")),
      )
    : [];
